import { Component, OnInit } from '@angular/core';
import { WallboardService } from '../../../services/wallboard/wallboard.service';
import { ConfigService } from '../../../services/config/config.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  selector: 'app-wallboard-add-life',
  templateUrl: './wallboard-add-life.component.html',
  styleUrls: ['./wallboard-add-life.component.css']
})
export class WallboardAddLifeComponent implements OnInit {

  formValid: boolean;
  showCombinedMetricsLife: boolean = false;

  constructor(
    public wallboardService: WallboardService,
    public router: Router,
    public configService: ConfigService,
    public messageService: MessageService,
    private route: ActivatedRoute,
  ) { }

  async ngOnInit() {
    this.checkRouteConditionLife();
     // Listen to router events to detect URL changes dynamically
     this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkRouteConditionLife();
      }
    });
    this.formValid = false;
    this.wallboardService.activeQueueConfigLife = {
      Announcements: '',
      QueueArn: '',
      QueueName: '',
      RotationDelay: '15',
      View: '',
      Thresholds: {
        red: {
          'ServiceLevel': 0,
          'Queue': 0,
          'Oldest': 0,
          'ASA': 0
        },
        yellow: {
          'ServiceLevel': 0,
          'Queue': 0,
          'Oldest': 0,
          'ASA': 0
        }
      }
    }
    await this.configService.getQueueList();
  }

  updateQueueARN(queueName: string) {
    this.configService.queueNamesList.map((queue: object) => {
      if (queue['queueName'] === queueName) {
        this.wallboardService.activeQueueConfigLife.QueueArn = queue['queueConfig']['arn'];
        console.log('wbService.activeQueueConfigLife.QueueArn set to: ');
        console.log(queue['queueConfig']['arn'])
      }
    })  
  }

  toggleAggregateView(aggregate: boolean) {
    if (aggregate) {
      let view = JSON.stringify(this.wallboardService.activeQueueConfigLife.View);
      this.wallboardService.activeQueueConfigLife = JSON.parse(JSON.stringify(this.wallboardService.newAggregateConfigLife));
      this.wallboardService.activeQueueConfigLife.View = JSON.parse(view);
    }
    else{
      this.ngOnInit();
    }
  }

  postConfig() {
    if(this.formValid){
        this.messageService.setNotification('saving ' + this.wallboardService.activeQueueConfigLife.View + '...', 'information', false);
        this.wallboardService.postConfigLife(this.configService.activeLOBLife).then((resp) => {
          console.log(resp);
          if(resp['status'] == 200){
            this.messageService.setNotification('Life Wallboard creation successful', 'success', true);
          }else{
            console.error(resp)
            this.messageService.setNotification('Life Wallboard creation failed.', 'error', true);
          }
        });
    }
    else{
      this.messageService.setNotification('There are problems with the current configuration values. Please review your selections and re-submit.', 'error', true);
    }
  }

  validateInput(){
    if('AggregateView' in this.wallboardService.activeQueueConfigLife && this.wallboardService.activeQueueConfigLife['AggregateView'] == true){
      this.validateAggregate();
    }else{
      this.validateSingle();
    }
    //console.log("form valid: " + String(this.formValid));
  }


  validateSingle(){
    this.formValid = true;
    if(this.wallboardService.activeQueueConfigLife.View.trim() == ''){
      this.formValid = false;
    }
    if(this.wallboardService.activeQueueConfigLife.QueueName.trim() == ''){
      this.formValid = false;
    }
  }


  validateAggregate(){
    this.formValid = true;
    if(this.wallboardService.activeQueueConfigLife.View.trim() == ''){
      this.formValid = false;
    }
    var combinedTitleLife = '';
      combinedTitleLife = this.wallboardService.activeQueueConfigLife['CombinedPane']['Title'];
      if(combinedTitleLife.trim() == ''){
        this.formValid = false;
      }
      var combinedQueueLife = [];
      combinedQueueLife = this.wallboardService.activeQueueConfigLife['CombinedPane']['QueueList'];
      if(combinedQueueLife.length == 0){
        this.formValid = false;
      }  
  }

  checkRouteConditionLife() {
    const urlPath = this.router.url; // Get the current URL
    this.showCombinedMetricsLife = urlPath === '/life/wallboard-life/add-life'; // Exact match
  }

  cancelSite(configactiveLOBLife){
    this.router.navigate(['/'+ configactiveLOBLife], {queryParams: {status: 'true'} } );
  }

}


